import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import TableEntitiesCode from '@/presentation/components/entities-and-geotargeting/table-entities/table-entities.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new TableEntitiesCode();

		return {
			isLoading: code.isLoading,
			filteredEntities: code.filteredEntities,
			areAllEntitiesAttached: code.areAllEntitiesAttached,
			hasCampaignFinished: code.hasCampaignFinished,
			checkboxTitle: code.checkboxTitle,
			onAllEntitiesCheckboxClicked: code.onAllEntitiesCheckboxClicked.bind(code),
			onEntityAttachedStatusChanged: code.onEntityAttachedStatusChanged.bind(code),
			retrieveNameStylingClassNameForEntity: code.retrieveNameStylingClassNameForEntity.bind(code),
			retrieveDegreeLevelFullNameForEntity: code.retrieveDegreeLevelFullNameForEntity.bind(code),
			retrieveDegreeLevelAbbreviatedNameForEntity: code.retrieveDegreeLevelAbbreviatedNameForEntity.bind(code),
			retrievePremiumnessFullNameForEntity: code.retrievePremiumnessFullNameForEntity.bind(code),
			retrievePremiumnessAbbreviatedNameForEntity: code.retrievePremiumnessAbbreviatedNameForEntity.bind(code),
			retrievePremiumnessStylingClassNameForEntity: code.retrievePremiumnessStylingClassNameForEntity.bind(code),
			toggleVisibilityOfChildrenOfEntity: code.toggleVisibilityOfChildrenOfEntity.bind(code),
			isParentHidden: code.isParentHidden.bind(code)
		};
	}
});
